import { FC } from 'react';

import PhoneIcon from '@icons/18/phone.svg';
import MailIcon from '@icons/mail.svg';

import styles from './TopContactsCards.module.scss';
import { TopContactsCardsProps } from './types';

const TopContactsCards: FC<TopContactsCardsProps> = ({ cards }) => (
    <div className={styles.topContacts_row}>
        {cards.map(card => (
            <article key={card.id} className={`${styles.topContacts_card} ${styles.topContacts_card_audience}`}>
                <h2 className={styles.topContacts_title}>{card.title}</h2>
                <p className={styles.topContacts_schedule}>{card.schedule}</p>
                <div className={styles.topContacts_contacts}>
                    <div className={styles.topContacts_contactRow}>
                        <span
                            className={`${styles.topContacts_contactIcon} ${styles.topContacts_contactIcon_audience}`}
                            aria-hidden
                        >
                            <PhoneIcon />
                        </span>
                        <a href={`tel:${card.phoneTel}`} className={styles.topContacts_link}>
                            {card.phoneLabel}
                        </a>
                    </div>
                    <div className={styles.topContacts_contactRow}>
                        <span
                            className={`${styles.topContacts_contactIcon} ${styles.topContacts_contactIcon_audience}`}
                            aria-hidden
                        >
                            <MailIcon />
                        </span>
                        <a href={`mailto:${card.email}`} className={styles.topContacts_link}>
                            {card.email}
                        </a>
                    </div>
                </div>
            </article>
        ))}
    </div>
);

export default TopContactsCards;
